import React from "react";
import { Progress, Image, Text, Box, BackgroundImage, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { webPlayerStore } from "../store/webPlayerStore";

interface IGameLoadingProps {
	progress: number;
}

export const GameLoading = (props: IGameLoadingProps) => {
	const { t } = useTranslation();
	const { progress } = props;

	const gameConfig = webPlayerStore((state) => state.gameConfig);

	const showFullLogo =
		gameConfig.PublicWebClientConfig.FullLogoUrl && !gameConfig.PublicWebClientConfig.SplashImageUrl;

	if (progress >= 1) return null;

	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				position: "relative",
				"::before": {
					content: `""`,
					position: "absolute",
					inset: 0,
					backgroundImage: `url(${gameConfig.PublicWebClientConfig.SplashImageUrl ?? ""})`,
					backgroundPosition: "center",
					filter: "blur(40px)"
				}
			}}
		>
			<BackgroundImage
				src={gameConfig.PublicWebClientConfig.SplashImageUrl ?? ""}
				sx={{
					position: "absolute",
					inset: 0,
					zIndex: 1,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					backgroundSize: "contain",
					backgroundRepeat: "no-repeat"
				}}
			>
				<Stack w={700} spacing={40} sx={{ minHeight: !showFullLogo ? "75vh" : undefined }}>
					{showFullLogo && (
						<Image sx={{ maxWidth: 700 }} src={gameConfig.PublicWebClientConfig.FullLogoUrl} />
					)}
					<Box sx={{ position: "relative", marginTop: "auto" }}>
						<Progress
							value={progress * 100}
							size={36}
							styles={(theme) => ({ root: { backgroundColor: theme.colors.dark[4] } })}
						/>
						<Box
							sx={{
								position: "absolute",
								inset: 0,
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}}
						>
							<Text component="strong" c="white">
								{t("web_player.loading_message.0")}
							</Text>
						</Box>
					</Box>
				</Stack>
			</BackgroundImage>
		</Box>
	);
};
